/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { ApiSrc } from "../../../resources/ApiSrc";
import { GetResultObject, PostRequest } from "../../API";

const TYPES = {
    REQUEST_WAYBILL_LIST: "REQUEST_WAYBILL_LIST",
    
    REQUEST_WAYBILL_LIST_SUCCESS: "REQUEST_WAYBILL_LIST_SUCCESS",
    REQUEST_WAYBILL_LIST_FAILED: "REQUEST_WAYBILL_LIST_FAILED",   
    
    REQUEST_WAYBILL_ARRIVED_LIST_SUCCESS: "REQUEST_WAYBILL_ARRIVED_LIST_SUCCESS",

    REQUEST_CREATE_WAYBILL: "REQUEST_CREATE_WAYBILL",
    REQUEST_CREATE_WAYBILL_SUCCESS: "REQUEST_CREATE_WAYBILL_SUCCESS",
    REQUEST_CREATE_WAYBILL_SUCCESS_1: "REQUEST_CREATE_WAYBILL_SUCCESS_1",

    REQUEST_DETAIL_WAYBILL: "REQUEST_DETAIL_WAYBILL",
    REQUEST_DETAIL_WAYBILL_SUCCESS: "REQUEST_DETAIL_WAYBILL_SUCCESS",

    REQUEST_UPDATE_WAYBILL: "REQUEST_UPDATE_WAYBILL",
    REQUEST_UPDATE_WAYBILL_SUCCESS: "REQUEST_UPDATE_WAYBILL_SUCCESS",
    REQUEST_UPDATE_WAYBILL_ARRIVED_SUCCESS: "REQUEST_UPDATE_WAYBILL_ARRIVED_SUCCESS",

    CLEAR_WAYBILL: "CLEAR_WAYBILL",
    REQUEST_DELETE_WAYBILL_SUCCESS: "REQUEST_DELETE_WAYBILL_SUCCESS"
};
  
const getWaybillList = (body, params) => {
    return (dispatch) => {
      dispatch({
        type: TYPES.REQUEST_WAYBILL_LIST,
        payload: {},
      });
      PostRequest(
          ApiSrc.LIST_WAYBILL, body, params
      ).then(result => {
        GetResultObject(result, 'data.content', 200, (data, page) => {
          dispatch({
            type: TYPES.REQUEST_WAYBILL_LIST_SUCCESS,
            payload: {data: data, ...page},});
          })    
       })
  
    }
}

const getWaybillArrivedList = (body, params) => {
  return (dispatch) => {    
    PostRequest(
        ApiSrc.LIST_WAYBILL, body, params
    ).then(result => {
      GetResultObject(result, 'data.content', 200, (data, page) => {
        dispatch({
          type: TYPES.REQUEST_WAYBILL_ARRIVED_LIST_SUCCESS,
          payload: {data: data, ...page},});
        })    
     })

  }
}

const createWaybill = (body, params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_CREATE_WAYBILL,
      payload: {},
    });
    PostRequest(
        ApiSrc.CREATE_WAYBILL, body, params
    ).then(result => {
      GetResultObject(result, 'data', 200, (data, page) => {
        dispatch({
          type: TYPES.REQUEST_CREATE_WAYBILL_SUCCESS,
          payload: {data: data, ...page},});
        })    
     })

  }
}

const updateWaybill = (body, params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_UPDATE_WAYBILL,
      payload: {},
    });
    PostRequest(
        ApiSrc.UPDATE_WAYBILL, body, params
    ).then(result => {
      GetResultObject(result, 'data', 200, (data, page) => {
        dispatch({
          type: TYPES.REQUEST_UPDATE_WAYBILL_SUCCESS,
          payload: {data: data, ...page},});
        })    
     })

  }
}

const updateWaybillSuccess = (data) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_UPDATE_WAYBILL_SUCCESS,
      payload: {data: data},
    }); 
  }
}

const updateWaybillArrivedSuccess = (data) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_UPDATE_WAYBILL_ARRIVED_SUCCESS,
      payload: {data: data},
    }); 
  }
}

const deleteWaybillSuccess = (data) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_DELETE_WAYBILL_SUCCESS,
      payload: {data: data},
    }); 
  }
}



const createWaybillSuccess = (data) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_CREATE_WAYBILL_SUCCESS_1,
      payload: {data: data},
    }); 
  }
}


const getWaybillDetail = (body, params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_DETAIL_WAYBILL,
      payload: {},
    });
    PostRequest(
        ApiSrc.DETAIL_WAYBILL, body, params
    ).then(result => {
      GetResultObject(result, 'data', 200, (data, page) => {

        PostRequest(ApiSrc.LIST_WAYBILL_LOG, body).then(lresult => {
          GetResultObject(lresult, 'data', 200, (data1, page) => {
            data.logs = data1
            dispatch({
              type: TYPES.REQUEST_DETAIL_WAYBILL_SUCCESS,
              payload: {data: data, ...page},});
            })    
          })
        })        
     })

  }
}

const clearWaybill = () => {
  return (dispatch) => {
    dispatch({
      type: TYPES.CLEAR_WAYBILL,
      payload: {},
    })
  }
}


export default {
    TYPES, getWaybillList
    , getWaybillArrivedList
    , createWaybill
    , getWaybillDetail
    , updateWaybill
    , updateWaybillSuccess
    , updateWaybillArrivedSuccess
    , clearWaybill
    , createWaybillSuccess
    , deleteWaybillSuccess
}